import { render, staticRenderFns } from "./PeriodSelector.vue?vue&type=template&id=5b85c53a&scoped=true"
import script from "./PeriodSelector.vue?vue&type=script&lang=js"
export * from "./PeriodSelector.vue?vue&type=script&lang=js"
import style0 from "./PeriodSelector.vue?vue&type=style&index=0&id=5b85c53a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b85c53a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b85c53a')) {
      api.createRecord('5b85c53a', component.options)
    } else {
      api.reload('5b85c53a', component.options)
    }
    module.hot.accept("./PeriodSelector.vue?vue&type=template&id=5b85c53a&scoped=true", function () {
      api.rerender('5b85c53a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/attendance/components/PeriodSelector.vue"
export default component.exports